import React, { useEffect, useState, useRef } from "react";

const CountUp = ({ targetValue, duration = 2000, suffix }) => {
  const [count, setCount] = useState(0);
  const hasAnimated = useRef(false); // Use ref to prevent re-renders
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !hasAnimated.current) {
          hasAnimated.current = true; // Ensure it runs only once
          let startTime = performance.now();

          const animateCount = (currentTime) => {
            const elapsedTime = currentTime - startTime;
            const progress = Math.min(elapsedTime / duration, 1);
            const newValue = Math.floor(progress * targetValue);

            setCount(newValue);

            if (progress < 1) {
              requestAnimationFrame(animateCount);
            } else {
              setCount(targetValue);
            }
          };

          requestAnimationFrame(animateCount);
        }
      },
      { threshold: 0.5 }
    );

    const currentRef = ref.current;
    if (currentRef) observer.observe(currentRef);

    return () => {
      if (currentRef) observer.unobserve(currentRef);
    };
  }, [targetValue, duration]); // Removed `hasAnimated` from dependencies

  return (
    <div ref={ref} className="count-animation">
      {count.toLocaleString()}{suffix}
    </div>
  );
};
export default CountUp;
